import Vue from 'vue';
import ViewModelBase from '../../../../core/v2/app/viewModelBase';
import DataSource from '../../../../core/v2/data/data-source';
import DataRecord from '../../../../core/v2/data/data-record';
import AppSystemModel from '../../../../services/v2/model/app-system-model';
import CreateAppSystemRequestModel from '../../../../services/v2/model/create-app-system-request-model';

export default class AppSystemViewModel extends ViewModelBase {
  visibleDialog?: 'create' | 'edit' = undefined;
  appSystem?: AppSystemModel = undefined;

  async initialize(): Promise<void> {
    await this.appSystemsDataSource.select();
  }

  appSystemsDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.core.appSystems.getAppSystems,
    updateCommand: Vue.$service.v2.api.core.appSystems.updateAppSystem,
    insertCommand: Vue.$service.v2.api.core.appSystems.createAppSystem,
    deleteCommand: Vue.$service.v2.api.core.appSystems.deleteAppSystem,
  });

  async onDeleteClick(entry: DataRecord<AppSystemModel>) {
    Vue.$dialog.confirmDelete(1)
      .then(async (isConfirmed) => {
        if (isConfirmed) {
          await this.appSystemsDataSource.delete(entry.data.id!);
          await this.appSystemsDataSource.select();
        }
      });
  }

  showCreateDialog() {
    this.appSystem = new CreateAppSystemRequestModel();
    this.visibleDialog = 'create';
  }

  showEditDialog(editedAppSystem: AppSystemModel) {
    this.appSystem = editedAppSystem;
    this.visibleDialog = 'edit';
  }

  closeDialog() {
    this.visibleDialog = undefined;
    this.appSystem = undefined;
  }

  async createOrEditAppSystem() {
    if (!this.appSystem) {
      return;
    }
    if (this.visibleDialog === 'create') {
      await this.appSystemsDataSource.insert(this.appSystem);
    } else if (this.visibleDialog === 'edit') {
      await this.appSystemsDataSource.update(this.appSystem);
    }
    this.closeDialog();
    await this.appSystemsDataSource.select();
  }
}
